export default __webpack_public_path__ + "static/media/loader.8d46c61d.svg";